import React from "react";
import { CustomButton } from "./CustomButton";
import { Box, ButtonProps } from "@mui/material";

type Props = ButtonProps & {
  icon: React.ReactNode;
  style?: React.CSSProperties;
};

export const IconButton = ({ icon, ...props }: Props) => {
  return (
    <CustomButton
      {...props}
      variant="outlined"
      customColor="#FFFFFF"
      textColor="#1D3E70"
      customSize="fit"
      sx={{
        minWidth: "auto",
        p: 1,
        borderColor: "#1D3E70",
      }}
    >
      <Box sx={{ opacity: props.disabled ? "0.4" : "1" }}>{icon}</Box>
    </CustomButton>
  );
};
